import { HttpClient, HttpHeaders } from "@angular/common/http";
import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { AccountService } from "src/app/services/account.service";
import { trigger, transition, style, animate } from "@angular/animations";
import { FormControl, FormGroup } from "@angular/forms";
import * as XLSX from "xlsx";
import { UrlConstants } from "src/app/models/urlConstants";

export interface historicalData {
  CLOSE_PRICE: number;
  HIGH_PRICE: number;
  LOW_PRICE: number;
  OPEN_PRICE: number;
  SYMBOL_CODE: string;
  TRADE_COUNT: number;
  TRADE_DATE: Date;
  TRADE_VALUE: number;
  TRADE_VOLUME: number;
}

@Component({
  selector: "app-historical",
  templateUrl: "./historical.component.html",
  styleUrls: ["./historical.component.scss"],
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ transform: "translateX(100%)", opacity: 0 }),
        animate("500ms", style({ transform: "translateX(0)", opacity: 1 })),
      ]),
      transition(":leave", [
        style({ transform: "translateX(0)", opacity: 1 }),
        animate("500ms", style({ transform: "translateX(100%)", opacity: 0 })),
      ]),
    ]),
  ],
})
export class HistoricalComponent implements OnInit {
  @Input() symbolCode: string;
  @Input() reuters: string;
  @Input() companyName: string;
  isDepthLoading: boolean;
  data: historicalData[] = [];
  show: boolean = false;
  isDarkTheme: boolean;

  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(new Date()),
  });

  constructor(private accService: AccountService, private http: HttpClient) {}

  ngOnChanges(changes: SimpleChanges) {
    this.symbolCode = changes?.symbolCode?.currentValue;
    if (this.symbolCode) {
      this.isDepthLoading = true;
      this.fetchCompanyMarketDepth().subscribe((res) => {
        this.data = [];
        this.data = res as historicalData[];
        this.isDepthLoading = false;
      });
    }
    this.range.valueChanges.subscribe((value) => {
      this.fetchCompanyMarketDepth().subscribe((res) => {
        this.data = [];
        this.data = res as historicalData[];
        this.isDepthLoading = false;
      });
    });
  }

  @ViewChild("TABLE") table: ElementRef;
  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(
      this.table.nativeElement
    ); //converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Historical");

    /* save to file */
    XLSX.writeFile(wb, "Historical - " + this.data[0].SYMBOL_CODE + ".xlsx");
  }

  fetchCompanyMarketDepth() {
    if (this.symbolCode) {
      return this.http.post(
        UrlConstants.feedUrl + "/api/Feed/GetSymbolHistory",
        {
          SymbolCode: this.symbolCode,
          Skip: 0,
          Take: 1000,
          FromDate: this.range.controls.start.value,
          ToDate: this.range.controls.end.value,
        }
      );
    }
  }

  ngOnInit() {
    this.isDarkTheme =
      localStorage.getItem("darktheme") == "dark" ? true : false;}
}
